import { StakeInputError, StakeInputErrors } from '../types';
import { StakeInputValidator, ValidatorMap, stakeInputValidators, validateAll } from './validators';

type PredictionsStakeInputError = Extract<
    StakeInputError,
    'EXCEED_SINGLE_WALLET_BALANCE' | 'BELOW_MIN' | 'ABOVE_MAX' | 'EXCEED_MAX_SINGLE_WAGER'
>;

// Predictions runs the Betr Cash set minus the market stake limit (EXCEED_STAKE_LIMIT);
// balance checks and RG wager limits still apply. Total stake validation reuses the cash
// set as-is: the Betr Bucks check is inert because predictions has no Betr Bucks stake.
export const predictionsStakeInputValidators: ValidatorMap<PredictionsStakeInputError, StakeInputValidator> = {
    [StakeInputErrors.ExceedSingleWalletBalance]: stakeInputValidators[StakeInputErrors.ExceedSingleWalletBalance],
    [StakeInputErrors.BelowMin]: stakeInputValidators[StakeInputErrors.BelowMin],
    [StakeInputErrors.AboveMax]: stakeInputValidators[StakeInputErrors.AboveMax],
    [StakeInputErrors.ExceedMaxSingleWager]: stakeInputValidators[StakeInputErrors.ExceedMaxSingleWager],
};

const predictionsStakeInputValidationOrder: Array<PredictionsStakeInputError> = [
    StakeInputErrors.ExceedSingleWalletBalance,
    StakeInputErrors.ExceedMaxSingleWager,
    StakeInputErrors.AboveMax,
    StakeInputErrors.BelowMin,
];

export const validatePredictionsStakeInput = (inputs: StakeInputValidator) =>
    validateAll<StakeInputValidator, PredictionsStakeInputError>(
        inputs,
        predictionsStakeInputValidators,
        predictionsStakeInputValidationOrder
    );
